














































import AbpBase from "@/lib/abpbase";
import { Component } from "vue-property-decorator";
// import md5 from "@/lib/md5";
import Util from "@/lib/util";
import ajax from "@/lib/ajax";
import appconst from "@/lib/appconst";
import Channel from "@/lib/channel";

/**
 * 单点登录页面
 */
@Component
export default class extends AbpBase {
  loginModel: any = {
    userNameOrEmailAddress: "",
    password: "",
    rememberMe: false,
  };
  routerQuery: any = {}; // 路由参数

  rules = {
    userNameOrEmailAddress: [
      { required: true, message: "请输入用户名", trigger: "blur" },
    ],
    password: [{ required: true, message: "请输入密码", trigger: "blur" }],
  };

  created() {
    const tenantId = abp.utils.getCookieValue("Abp.TenantId");
    if (tenantId !== "1") {
      Util.abp.multiTenancy.setTenantIdCookie(1);
    }
    this.routerQuery = (this.$router as any).history.current.query;
    this.autologin();
  }

  // 在单点登录平台上注册业务系统用户
  login() {
    (this.$refs.loginform as any).validate(async (valid) => {
      if (valid) {
        let payload = Object.assign({}, this.loginModel);
        payload.password = Util.Encrypt(payload.password);
        payload.appId = this.routerQuery.appid;
        payload.ssoUserId = this.routerQuery.userid;
        this.$Loading.start();
        let res = await ajax.post(
          "/api/TokenAuth/LoginSsoRegisterUser",
          payload
        );
        this.$Loading.finish();
        let result = res.data.result;
        if (result) {
          if (result.code === 200) {
            // 注册成功，调用单点登录认证接口 AutoAuthenticate
            this.routerQuery.loginid = this.loginModel.userNameOrEmailAddress;
            this.autologin();
          } else {
            // 注册失败，弹窗提醒
            this.$Modal.error({
              title: "提示",
              content: result.errorMsg,
            });
          }
        }
      }
    });
  }

  /**
   * 单点登录认证流程
   * @param query 路由参数
   */
  async autologin() {
    let username =
      this.routerQuery.id ||
      this.routerQuery.cipher ||
      this.routerQuery.token ||
      this.routerQuery.pcode ||
      this.routerQuery.loginid;
    let token =
      this.routerQuery.token ||
      this.routerQuery.ptickets ||
      this.routerQuery.code ||
      this.routerQuery.tokenCode ||
      this.routerQuery.captcha ||
      this.routerQuery.ticket ||
      this.routerQuery.oauth_token || 
      this.routerQuery.st;
    let appId = this.routerQuery.appId || this.routerQuery.appid;
    let ssoUserId = this.routerQuery.userid;
    let loginflag = this.routerQuery.loginflag; // 是否是首次登录 1-首次登录 2-非首次登录

    // 【示例1：http://192.168.2.210/#/loginsso?id=admin&token=4D8C5529-DD85-43F2-8AE4-1731673B673A】
    // 【示例2：http://192.168.2.210/#/loginsso?id=g1vyKa9OMvk%3D】 // id的值:用户名先做des加密再进行url编码
    // if (!username) {
    //   this.$Modal.warning({
    //     title: "提示",
    //     content:
    //       "单点登录参数错误",
    //   });
    //   return;
    // }

    console.log(this.routerQuery);
    if (loginflag != "1" || username != "-") {
      // 首次登录显示登录面板，非首次登录直接进入单点登录认证流程
      // 非首次登录，直接进入单点登录认证流程
      let loginModel = {
        userNameOrEmailAddress: username,
        token: token,
        appId: appId,
        ssoUserId: ssoUserId,
      };
      // await this.$store.dispatch({
      //   type: "app/autologin",
      //   data: loginModel,
      // });
      // sessionStorage.setItem("rememberMe", "0");
      // sessionStorage.setItem("userName", username);
      // console.log("单点登录成功");
      // this.$router.push("/main");
      // window.location.reload();

      this.$Loading.start();
      let res = await ajax.post("/api/TokenAuth/AutoAuthenticate", loginModel);
      this.$Loading.finish();
      let result = res.data.result;
      if (result) {
        if (result.code === 2000) {
          // 认证成功
          this.$Message.info({ content: "认证成功" });
          // 清空路由参数
          this.routerQuery = {};

          var tokenExpireDate = new Date(
            new Date().getTime() + 1000 * res.data.result.expireInSeconds
          );
          Util.abp.auth.setToken(result.accessToken, tokenExpireDate);
          Util.abp.utils.setCookieValue(
            appconst.authorization.encrptedAuthTokenName,
            result.encryptedAccessToken,
            tokenExpireDate,
            Util.abp.appPath
          );
          //存储用户所属分区
          localStorage.setItem("LoginUserPartitionId", result.partitionId);
          sessionStorage.setItem("rememberMe", "0");
          sessionStorage.setItem("userName", username);
          this.$router.push("/main");
          // 需要等待主页加载完成后执行reload操作，否则window.location始终是loginsso，将无限跳转loginsso界面
          let interval = setInterval(() => {
            if (window.location.href.indexOf("loginsso") === -1) {
              window.location.reload();
              // 浏览器内发送通知消息，首页接收到消息后更新显示的用户姓名
              clearInterval(interval);
              Channel.send(
                Channel.channelEnum.REAL_EVENT.name,
                "loginsso-success"
              );
            }
          }, 1000);
        } else if (result.code === 50302) {
          console.log(result.redirectUrl);
          window.location.href = result.redirectUrl;
        } else if (result.code === 50005) {
          this.$Modal.error({
            title: "提示",
            content: result.errorMsg,
          });
        } else {
          console.log(result);
          // 认证失败
          this.$Modal.error({
            title: "提示",
            content: result.errorMsg,
            onOk: () => {
              this.$router.push("/login");
            },
          });
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/loginsso.vue